var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestream({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.017 8.501H10.87v2.88h1.129c1.168 0 1.751-.447 1.751-1.428v-.068c0-.981-.617-1.384-1.733-1.384z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12c6.628 0 12-5.373 12-12S18.628 0 12 0zm2.148 17.994l-2.454-4.267h-.824v4.267H7.457V5.941h4.712c3.164 0 4.888 1.253 4.888 3.809v.068c0 1.726-.896 2.684-2.165 3.175l2.912 5.002h-3.656z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestream);
export default __webpack_public_path__ + "static/media/restream.da109720666773e74568728b6033773b.svg";
export { ForwardRef as ReactComponent };